export enum CookieConsentProviderType {
  DEFAULT = '',
  ONE_TRUST = 'one_trust'
}
